/** @format */

import {styled} from '@mui/material/styles';
import {ToggleButton, ToggleButtonGroup} from '@mui/material';

export const Root = styled(ToggleButtonGroup)(({theme}) => ({
  width: 'max-content',
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  gap: '1px',
  border: 'none',

  [`${theme.breakpoints.down('sm')}`]: {
    flexDirection: 'column',
    width: '100%',
  },
}));

export const StyledToggleButton = styled(ToggleButton)(({theme}) => ({
  width: 'max-content',
  height: '32px',
  padding: theme.spacing(0, 2),
  borderRadius: 0,
  transition: '0s',
  background: theme.palette.semantic_light?.surface.surface1,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  '&.MuiButtonBase-root': {
    border: 'none',
    margin: 0,

    '&:hover': {
      background: theme.palette.semantic_light?.surface.surface1,
    },
  },

  color: theme.palette.figma_gray_middle_dark?.dark,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  textTransform: 'none',

  '&.Mui-selected': {
    background: theme.palette.figma_primary?.dark,
    color: theme.palette.semantic_dark?.primary.on,

    '&:hover': {
      background: theme.palette.figma_primary?.dark,
    },
  },

  [`${theme.breakpoints.down('sm')}`]: {
    width: '100%',
  },
}));
